"use client";

import {
  getPlaceDetails as getPlaceDetailsClient,
  getPlaceIdFromPostalCode,
  getPlace,
} from "./place-details.client";

/**
 * React Query helpers for Google Places lookups so results are cached
 */

export function getPlaceIdQueryOptions(postalCode: string) {
  return {
    queryKey: ["google-places", "place-id", postalCode] as const,
    queryFn: async () => {
      if (!postalCode) return null as string | null;
      return getPlaceIdFromPostalCode(postalCode);
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  } as const;
}

export function getPlaceDetailsQueryOptions(placeId: string) {
  return {
    queryKey: ["google-places", "place-details", placeId] as const,
    queryFn: async () => {
      if (!placeId) return null;
      return getPlaceDetailsClient(placeId);
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  } as const;
}

/**
 * Get Google Place object for advanced usage
 * This function returns the raw Google Place object with fetched fields
 * @param placeId - The Google Place ID
 * @returns Google Place object
 */
export async function getPlaceDetails(placeId: string) {
  return getPlace(placeId);
}
